/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_3fb927dd"]'><div><div :class='["picker-demo-title"]'>Config format:</div><cube-time-picker :format="(format)" @change='(e)=>__invoke(e, [["onChange"]])'/><div :class='["demo-data"]' v-if="(changeParams.length)"><div :class='["key"]'>change 事件参数：</div><div :class='["value"]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_3fb927dd"}'>
.picker-demo-title
  margin-bottom: 8px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        margin-left: 10px
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_3fb927dd"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_3fb927dd"}
  /** script content **/
  require("./config-format-picker.mpx.js?isComponent&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./config-format-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fconfig-format-picker3fb927dd%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_3fb927dd"],
    ctorType: "component",
    outputPath: "components/config-format-picker3fb927dd/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-time-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/time-picker/index.mpx?isComponent&outputPath=components%2Findex057b2bbb%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>